<template>
    <div class="transfer">
        <Header title="用户转账" :show-back="true"/>
        <div class="wrapper">
            <van-field
                    class="cell"
                    v-model="account"
                    label="对方账号"
                    label-class="cell-label"
                    type="text"
                    placeholder="请输入对方账号"/>
            <van-field
                    class="cell"
                    v-model="value"
                    label="转账数量"
                    label-class="cell-label"
                    placeholder="请输入数量">
            </van-field>
            <van-field
                    class="cell"
                    v-model="code"
                    label="验证码"
                    label-class="cell-label"
                    placeholder="请输入验证码">
                <span class="code-btn" slot="button" id="getCodeBtn" @click="getCode">获取验证码</span>
            </van-field>
            <button class="form-item-btn" @click="onConfirm">确认</button>
        </div>
        <!--密码框-->
        <van-dialog
                v-model="showPsdDialog"
                title="转账"
                confirmButtonColor="#1FC26D"
                show-cancel-button
                @confirm="onTransfer"
                @cancel="cancelEvent">
            <input type="password" placeholder="请输入交易密码" class="pwdInput" v-model="pay_password" autocomplete="off"/>
        </van-dialog>
    </div>
</template>

<script>
    import Header from "../../components/header";

    export default {
        components: {
            Header
        },
        data() {
            return {
                account: '',
                value: "",
                code: "",
                pay_password: '',
                showPsdDialog: false,
                codeFlag: false,
            };
        },
        methods: {
            // 获取验证码
            getCode() {
                if (this.codeFlag) {
                    return
                }
                this.codeFlag = true;
                let btn = document.getElementById("getCodeBtn");
                let num = 60;
                let t = setInterval(() => {
                    btn.innerHTML = `${num}秒`;
                    num--;
                    if (num <= 0) {
                        this.codeFlag = false;
                        btn.innerHTML = "获取验证码";
                        clearInterval(t);
                    }
                }, 1000);
                this.ajax.post("appapi/user/sendSmsCode", {}).then((res) => {
                    if (res.data.code === 1) {
                        this.$toast(res.data.msg);
                    } else {
                        clearInterval(t);
                        this.codeFlag = false;
                        btn.innerHTML = "获取验证码";
                    }
                })
            },
            // 唤起密码框
            onConfirm() {
                if (!this.account) {
                    this.$toast("请输入账号");
                    return
                }
                if (!this.value) {
                    this.$toast("请输入转账数量");
                    return
                }
                if (!this.code) {
                    this.$toast("请输入验证码");
                    return
                }
                this.showPsdDialog = true;
            },
            // 密码框确认按钮
            onTransfer() {
                if (!this.pay_password) {
                    this.$toast("请输入交易密码");
                    return
                }
                this.showPsdDialog = false;
                let parmes = {
                    to: this.account,
                    num: this.value,
                    code: this.code,
                    pay_password: this.pay_password,
                    coin: "xmi"
                };
                this.ajax.post("appapi/user/transferBalance", parmes).then(res => {
                    if (res.data.code === 1) {
                        this.$toast(res.data.msg);
                        // 清空输入框数据
                        this.account = "";
                        this.value = "";
                        this.code = "";
                        this.pay_password = "";
                    } else {
                        this.pay_password = "";
                        this.code = "";
                    }
                });
            },
            cancelEvent() {
                this.showPsdDialog = false
            }
        }
    };
</script>


<style lang="scss">
    .transfer {
        .wrapper {
            padding: 30px;
        }

        .form {
            height: 636px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 12px 34px 0px rgba(48, 77, 120, 0.1);
            border-radius: 20px;
        }

        .cell {
            padding: 60px 40px 25px;

            &-label {
                font-size: 30px;
                color: #333;
                font-weight: bold;
            }

            input {
                font-size: 24px;
                color: #c5c4c4;
            }

            .code-btn {
                font-size: 28px;
                cursor: pointer;
                font-weight: bold;
                color: rgba(31, 194, 109, 1);
                line-height: 20px;
            }
        }

        .form-item-btn {
            margin-top: 50px;
        }

        .pwdInput {
            display: block;
            width: 80%;
            height: 78px;
            background: #F9F9F9;
            padding: 20px 30px;
            box-sizing: border-box;
            margin: 20px auto;

        }
    }
</style>
